var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.LButton,{attrs:{"variant":"outline","tw-class":[
    'z-40 size-6 rounded-full p-0 invisible absolute left-1/2 -translate-x-1/2 opacity-0 transition-all duration-200 ease-in-out',
    _vm.placement === 'top'
      ? _vm.alwaysVisible
        ? 'visible opacity-100 -top-[18px]'
        : 'top-0 group-hover:-top-[18px] group-focus-within:-top-[18px]  group-focus-within:visible group-hover:visible group-hover:opacity-100'
      : _vm.alwaysVisible
        ? 'visible opacity-100 -bottom-[18px]'
        : 'bottom-0 group-hover:-bottom-[18px] group-focus-within:-bottom-[18px]  group-focus-within:visible group-hover:visible group-hover:opacity-100',
  ]},on:{"click":function($event){$event.stopPropagation();return _setup.openTransportationSlideOver.apply(null, arguments)}}},[_c('v-icon',{staticClass:"!text-gray-900",attrs:{"size":"16"}},[_vm._v("$vuetify.icons.plus")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }